import { getReviewsForUser } from '../../../actions/userReviews';
import { store } from '../../../index';

export function* onGetReviewsForUser({ payload }) {
  const { dispatch } = store;
  dispatch(getReviewsForUser(payload.userId));
  yield true;
}
